/*
 * token在Cookie中存储的时间，单位为天，（js-cookie支持传传入时长/天，或者过期时间）
 */
export const cookieExpires = 0.2  // 同后端token过期时间


// 公众号主体使用数科的页面
export const jsApiSignByShuke = [
  // '/XiameBankAscendGoldWxCollecting',
]
